import { render } from "./AboutMissionAndVision.vue?vue&type=template&id=14666092&scoped=true"
import script from "./AboutMissionAndVision.vue?vue&type=script&lang=js"
export * from "./AboutMissionAndVision.vue?vue&type=script&lang=js"

import "./AboutMissionAndVision.vue?vue&type=style&index=0&id=14666092&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14666092"]])

export default __exports__